import { render, staticRenderFns } from "./ExpressInfo.vue?vue&type=template&id=a4e54bfc"
import script from "./ExpressInfo.vue?vue&type=script&lang=ts"
export * from "./ExpressInfo.vue?vue&type=script&lang=ts"
import style0 from "./ExpressInfo.vue?vue&type=style&index=0&id=a4e54bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports